import {createTheme} from "@mui/material";
import {SiteDataType} from "./generated/graphql";



export const createHQTheme = (siteData:SiteDataType) => {
    // offset colours are calculated during this phase, they are not automatically recalculated
    const defaultTheme = createTheme({
        palette:{
            primary: {
                main: siteData?.primaryColour??'#00203C'
            },
            secondary: {
                main:'#DE3E0F'
            }
        }
    });
    return createTheme(defaultTheme,
        {
            typography: {
                fontFamily: "'Open Sans',Helvetica,Arial,sans-serif",
                h1: {
                    fontSize: defaultTheme.typography.pxToRem(27),
                    fontWeight: 'bold'
                },
                h3: {
                    fontSize: defaultTheme.typography.pxToRem(20),
                    fontWeight:"bold"
                },
                button: {
                    fontWeight: '600',
                    //  textTransform: 'none'
                }
            },
            shape: {
                borderRadius: 20
            },
            palette: {
                primary: {
//            main: '#257f92'
                },
                secondary: {
                    main: '#DE3E0F'
                }
            },
            components: {
                MuiTextField: {
                    defaultProps: {
                        margin: "dense"
                    }
                },
                MuiMenu: {
                    styleOverrides: {
                        root: {
                            '& .MuiPaper-root': {
                                borderRadius: "5px"
                            }
                        }
                    }
                }
                /*MuiButton: {
                    styleOverrides: {
                        root: {
                            fontSize: "20px"
                        }
                    }
                }*/
            }
        });
};